import _Source from "../playmore/source"

class Source extends _Source {
  constructor() {
    super()
    this.inputs = {
      MAIN: "NONE",
      VOD: "NONE",
      HLS: "NONE",
      MULTICAST: "NONE",
      RF: "NONE",
      HDMI1: "HDMI1",
      HDMI2: "HDMI2",
      HDMI3: "HDMI3"
    }
  }
  _init = async () => {
    const current = await this.get().catch(err => _$.error(err))
    if (current !== this.inputs.MAIN) await this.set(this.inputs.MAIN).catch(err => _$.error(err))

    return true
  }

  get = async () => {
    if (playmore.platform.isAppForeground()) return "NONE"
    return playmore.device.getSource()
  }
  set = async source => {
    if (source !== "NONE") return playmore.device.setSource(source)
    playmore.platform.openPlatform()
    return true
  }
}

export default Source
